let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("95Qae")).then(() => parcelRequire('l4ZyA'));